var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages-user"},[_c('content-box',{attrs:{"title-left":true}},[_c('div',{staticClass:"whyc-breadcrumb",attrs:{"slot":"title"},slot:"title"},[_vm._v("当前位置：用户管理")]),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }